import { useTranslation } from 'react-i18next';

import { Skeleton } from 'shared/components/Skeleton';
import { Title as TileTitle } from 'shared/components/Tile';

import type { CumulativeGradesProps } from 'applications/GSP/entities/CumulativeGrades/types';
import type { InspiredGlobalStudyPlatformApiModelsChartGradeType as GradeType } from 'applications/GSP/shared/api/gsp';
import type { FC } from 'react';

interface TitleProps {
  gradeType?: GradeType;
  isLoading: CumulativeGradesProps['isLoading'];
}

export const Title: FC<TitleProps> = ({
  gradeType = 'Cumulative',
  isLoading,
}) => {
  const { t } = useTranslation();

  if (isLoading) {
    return (
      <TileTitle>
        <Skeleton width={200} />
      </TileTitle>
    );
  }

  return (
    <TileTitle>
      {t(`GSP.entities.cumulativeGrades.titles.${gradeType.toLowerCase()}`)}
    </TileTitle>
  );
};
